<template>
    <!-- 我的发票 -->
    <div class="customer_box">
        <div class="customer_search_box" style="position: initial;margin-bottom: 10px;">
            <div class="search-item">
                <span>商品信息:</span>
                <el-input style="width: 180px;" clearable placeholder="请输入商品编号/商品名称" size="small" v-model="filterinfo.search"></el-input>
            </div>
            <div class="search-item">
                <span>生产厂家:</span>
                <el-input style="width: 160px;" clearable placeholder="请输入生产厂家" size="small" v-model="filterinfo.productUnit"></el-input>
            </div>
            <div class="search-item">
                <span>批准文号:</span>
                <el-input style="width: 155px;" clearable placeholder="请输入批准文号" size="small" v-model="filterinfo.license"></el-input>
            </div>
            <div class="btn_box" style="display: flex;">
                <el-button class="btn_item" type="primary" size="small" @click="getFirstData(1)">查询</el-button>
                <el-button class="btn_item" size="small" @click="resetClick">重置</el-button>
                <!-- <el-button class="btn_item" type="primary" size="small" @click="batchDownLoad">批量下载</el-button> -->
                <div @click="batchDownLoad" v-loading.fullscreen.lock="fullscreenLoading" class="downBtn"><img src="//assets/images/personal/downLoad.svg" alt=""> <span>华人企业资质下载</span></div>
            </div>
        </div>
        <div class="table_mode">
            <el-table :data="tableData" v-loading="loading" stripe style="width: 100%">
                <el-table-column prop="productCode" label="商品编号" min-width="150" align="center">

                </el-table-column>
                <el-table-column prop="productName" label="商品名称" min-width="220" align="center" fixed>

                </el-table-column>
                <el-table-column prop="produceUnit" label="生产厂家" min-width="230" align="center">

                </el-table-column>
                <el-table-column prop="norms" label="规格" min-width="360" align="center"></el-table-column>
                <el-table-column prop="license" label="批准文号" min-width="220" align="center"></el-table-column>
                <el-table-column prop="address" label="操作 " width="120" align="center" fixed="right">
                    <template slot-scope="scope">
                        <div class="table_btn">
                            <el-popover placement="right" width="400" trigger="click"   >
                                <el-table :data="downData" border  >
                                    <el-table-column width="150" property="name" align="center" label="文件名称"></el-table-column>
                                    <el-table-column prop="address" label="操作 " align="center">
                                        <template slot-scope="scope">
                                            <div class="table_btn">
                                                <div style="font-size: 14px;color: #1A9DFF;cursor: pointer;" class="btn_item" @click="downloadIt(scope.row.url)">下载</div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <!-- <el-button slot="reference">click 激活</el-button> -->
                                <div slot="reference" style="font-size: 14px;color: #1A9DFF;" class="btn_item" @click="dkxdClick(1,scope.row.goodsId,scope.row.batchCode,scope.row.productName)">首营资料下载</div>
                            </el-popover>
                          
                        </div>
                    </template>
                </el-table-column>
                <div slot="empty" class="nodata_box">
                    <img src="@/assets/images/index/nodata.png" />
                    <span class="txt">暂无数据哦~</span>
                </div>
            </el-table>
        </div>
        <div class="pagination_box">
            <el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[10, 20, 30, 40]" :page-size.sync="filterinfo.pageSize" :current-page.sync="filterinfo.page" :total="total" @current-change="getFirstData" @size-change="getFirstData(1)">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { handlerTableData, downloadFile } from '@/utils/common'
import JSZip from "jszip";
import FileSaver from "file-saver";
import axios from 'axios'
export default {
    name: 'MyInvoice',
    data() {
        return {
            loading: false,
            downData: [],
            total: 0,
            fullscreenLoading: false,
            filterinfo: {
                search: "",
                productUnit: "",
                license: "",
                page: 1,
                pageSize: 10
            },
            tableData: [

            ],
        };
    },
    created() {

    },
    mounted() {
        this.getFirstData()
    },
    computed: {

    },
    methods: {

        viewInvoice(url) {
            window.open(url)
        },
        viewOrder(orderNumber) {
            // window.open('https://www.aminer.cn/order/orderDetail?orderNumber=' + orderNumber)
            window.open(`${this.baseURL}/hr/#/orderPersDetail?orderNumber=${orderNumber}`)
            // window.open(`http://pc.fastjz.com:9528/home/main#/orderPersDetail?orderNumber=${orderNumber}`)
        },
        downloadIt(url) {
            window.open(url)
        },
        // 下载首营资料
        async downClick(goodsId) {
            // el.downTitle = '下载中'
            // console.log(el);
            // this.$forceUpdate()
            const res = await this.$orderApis.downloadLicense({ goodsId })
            //    if(res.data.code==100001) return this.$message.error(res.msg)
            if (res.status == 200) {
                downloadFile(res)
            }
            // else{
            //     this.$message.warning('该商品暂无首营资料，请联系业务经理处理')
            // }

        },
        async dkxdClick(licenseType, goodsId, batchCode, name) {
            // this.fullscreenLoading = true
            this.downData = []
            const res = await this.$api.firstReportPdf({
                licenseType,
                goodsId,
                batchCode
            })
            if (res.data.code !== 200) {
                this.open(goodsId)
            }
            // this.fullscreenLoading = false
            // window.open(res.data.data.pdfs[0])
            this.downData = res.data.data.pdfs.map(item => {
                return {
                    url: item,
                    name
                }
            })
            //   handleDownload(res.data.data)
        },
        open(goodsId) {
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          type: 'warning',
          message: h('p', null, [
            h('span', null, '暂无电子签章版的首营资料，是否下载图片压缩包形式的首营资料'),
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
            await  this.downClick(goodsId)
              instance.confirmButtonLoading = false;
              done();
            } else {
              done();
            }
          }
        }).then(action, instance, done => {
          this.$message({
            type: 'success',
            message: '下载成功 '
          });
        });
      },
        async batchDownLoad() {
            this.fullscreenLoading = true
            const res = await this.$api.companyPdf()
            this.fullscreenLoading = false
            if (res.data.code == 200) {
                window.open(res.data.data)
            }
        },
        // 点击重置
        resetClick() {

            this.filterinfo = {
                search: "",
                productUnit: "",
                license: "",
                page: 1,
                pageSize: 10
            }
            this.getFirstData()
        },
        // 获取我的客户列表
        getFirstData(num) {
            if (num == 1) {
                this.filterinfo.page = 1
            }
            let params = this.filterinfo
            this.loading = true
            this.$api.pcGoodsSearch(params).then((res) => {
                this.loading = false
                if (res.data.code === 200) {
                    this.tableData = res.data.data ? handlerTableData(res.data.data.list) : []
                    // this.tableData = res.data.data.list
                    this.total = res.data.data ? res.data.data.total : 0
                }
            });
        },
    }
};
</script>
<style lang="scss" scoped>
.customer_box {
    position: relative;
    padding-top: 4px;
}
.alert {
    display: flex;
    align-items: center;
    // width: 600px;
    // margin-left: 20px;
    // justify-content: center;
    font-weight: bold;

    background: #e6f4ff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #b8e1ff;
    padding: 5px;
    margin-bottom: 10px;
    font-size: 12px;
}
.downBtn {
    // width: 93px;
    padding: 2px 3px;
    height: 30px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #1a9dff;
    font-weight: 400;
    font-size: 14px;
    color: #1a9dff;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    margin-left: 8px;
    &:hover {
        color: #337cff;
        border: 1px solid #337cff;
    }
}
</style>